import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/Pages/ECommerce/dataTableStyle.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SwatchProvider } from '../src/Context/ComponentContext/SwatchContext';
import { VariationProvider } from './Context/ComponentContext/VariationContext';
import { ActiveSaleProvider } from './Context/active-sale-context/ActiveSaleContext';
import { AuthProvider } from './Context/Auth/AuthContext';
import { LastCallSaleProvider } from './Context/active-sale-context/LastCallSaleContext';
import { ActiveFinanceProvider } from './Context/ActiveFinanceContext/ActiveFinanceContext';
import { DashboardProvider } from './Context/DashboardContext/dashboardContext';
import DeviceRestriction from './deviceRestriction';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DashboardProvider>
      <LastCallSaleProvider>
        <ActiveSaleProvider>
          <ActiveFinanceProvider>
            <VariationProvider>
              <SwatchProvider>
                <AuthProvider>
                  <DeviceRestriction>
                    <App />
                  </DeviceRestriction>
                </AuthProvider>
              </SwatchProvider>
            </VariationProvider>
          </ActiveFinanceProvider>
        </ActiveSaleProvider>
      </LastCallSaleProvider>
    </DashboardProvider>
  </React.StrictMode>
);

reportWebVitals();